<template>
  <div class="main-container">
    <!-- 标题 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>升级类型设置</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="addOrUpdateHandle()"
        >新增</el-button>
      </div>
      
      <!-- 搜索工具栏 -->
      <el-form :inline="true" :model="searchForm" class="form-container">
        <el-form-item label="升级类型">
          <el-input v-model="searchForm.upgradeType" placeholder="升级类型" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="启用" value="启用"></el-option>
            <el-option label="禁用" value="禁用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">查询</el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 数据表格 -->
      <el-table
        :data="dataList"
        border
        v-loading="dataListLoading"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="upgradeName"
          header-align="center"
          align="center"
          label="规则名称"
        ></el-table-column>
        <el-table-column
          prop="upgradeType"
          header-align="center"
          align="center"
          label="升级类型"
        ></el-table-column>
        <el-table-column
          prop="upgradeDetails"
          header-align="center"
          align="center"
          label="升级详情"
        ></el-table-column>
        <el-table-column
          prop="additionalCost"
          header-align="center"
          align="center"
          label="附加费用"
        >
          <template slot-scope="scope">
            {{ scope.row.additionalCost }} 元
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          header-align="center"
          align="center"
          label="状态"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '启用' ? 'success' : 'info'">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          header-align="center"
          align="center"
          label="创建时间"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          header-align="center"
          align="center"
          width="200"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
            <el-button type="text" size="small" @click="updateStatusHandle(scope.row)" :style="{color: scope.row.status === '启用' ? '#F56C6C' : '#67C23A'}">
              {{ scope.row.status === '启用' ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" style="color: #F56C6C">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页控件 -->
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </el-card>
    
    <!-- 新增/修改弹窗 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './add-or-update.vue'
import { formatDate } from '@/utils/date.js'

export default {
  components: {
    AddOrUpdate
  },
  filters: {
    formatDate(time) {
      if (time) {
        return formatDate(new Date(time), 'yyyy-MM-dd HH:mm:ss')
      }
      return ''
    }
  },
  data() {
    return {
      searchForm: {
        upgradeType: '',
        status: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: '/jiaolianyuyue/upgraderule/list',
        method: 'get',
        // params: {
        //   page: this.pageIndex,
        //   limit: this.pageSize,
        //   upgradeName: this.searchForm.upgradeName,
        //   upgradeType: this.searchForm.upgradeType,
        //   status: this.searchForm.status
        // }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list
          this.totalPage = data.page.totalCount
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 更新状态
    updateStatusHandle(row) {
      const newStatus = row.status === '启用' ? '禁用' : '启用'
      this.$confirm(`确认${newStatus}该规则吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: `/jiaolianyuyue/upgraderule/status/${row.id}`,
          method: 'post',
          params: {
            status: newStatus
          }
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    // 删除
    deleteHandle(id) {
      this.$confirm('确定删除该规则吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/jiaolianyuyue/upgraderule/delete',
          method: 'post',
          data: [id]
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    // 重置搜索条件
    resetSearch() {
      this.searchForm = {
        upgradeType: '',
        status: ''
      }
      this.getDataList()
    }
  }
}
</script>

<style scoped>
.main-container {
  padding: 20px;
}
.form-container {
  margin-bottom: 20px;
}
</style> 